module.exports = __webpack_public_path__ + "e0106718/img/SOURCERY_poweredby_web.9819842b.png";